const preloadedAssets = new Set<string>()

type ImagePreloadAsset = {
  href: string
  type?: string
}

export function preloadImages(assets: ImagePreloadAsset[]): void {
  if (typeof document === 'undefined') return

  for (const asset of assets) {
    if (preloadedAssets.has(asset.href)) continue

    const link = document.createElement('link')
    link.rel = 'preload'
    link.as = 'image'
    link.href = asset.href
    if (asset.type) link.type = asset.type
    document.head.appendChild(link)
    preloadedAssets.add(asset.href)
  }
}
